import { Component, inject, OnInit } from '@angular/core';
import { MatToolbar } from '@angular/material/toolbar';
import { MatIcon } from '@angular/material/icon';
import { MatAnchor, MatIconAnchor, MatIconButton } from '@angular/material/button';
import { AuthService, UserInfo } from '../../services/auth.service';
import { AsyncPipe, NgIf } from '@angular/common';
import { NavigationEnd, Router, RouterLink } from '@angular/router';
import { filter, map, Observable, shareReplay, startWith } from 'rxjs';
import { AdminLayoutService } from '../../services/admin-layout.service';
import { MatMenu, MatMenuItem, MatMenuTrigger } from '@angular/material/menu';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { environment } from '../../../environments/environment';
import { MatDivider } from '@angular/material/divider';
import { NotificationBellComponent } from './notification-bell/notification-bell.component';
import { AppTheme, ThemeService } from '../../services/theme.service';
import { MatDialog } from '@angular/material/dialog';
import { InfoDialogComponent } from '../info-dialog/info-dialog.component';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { LoadingService } from '../../services/loading.service';
import { MatBadge } from '@angular/material/badge';
import { AppUpdateService } from '../../services/app-update.service';

@Component({
  selector: 'app-navbar',
  standalone: true,
  imports: [
    MatToolbar,
    MatIcon,
    MatIconButton,
    AsyncPipe,
    RouterLink,
    MatAnchor,
    MatMenuTrigger,
    MatMenu,
    MatMenuItem,
    MatIconAnchor,
    MatDivider,
    NotificationBellComponent,
    NgIf,
    MatProgressBarModule,
    MatBadge,
  ],
  templateUrl: './navbar.component.html',
  styleUrl: './navbar.component.scss',
})
export class NavbarComponent implements OnInit {
  public authService = inject(AuthService);
  private router = inject(Router);
  public adminLayoutService = inject(AdminLayoutService);
  private breakpointObserver = inject(BreakpointObserver);
  private themeService = inject(ThemeService);
  private dialog = inject(MatDialog);
  public isLoading$ = inject(LoadingService).isLoading$;
  public updateService = inject(AppUpdateService);

  protected readonly environment = environment;

  isAdminRoute$!: Observable<boolean>;
  isHandset$: Observable<boolean> = this.breakpointObserver.observe(Breakpoints.Handset).pipe(
    map((result) => result.matches),
    shareReplay(),
  );

  activeTheme: AppTheme = this.themeService.getActiveTheme();

  ngOnInit(): void {
    this.isAdminRoute$ = this.router.events.pipe(
      filter((e): e is NavigationEnd => e instanceof NavigationEnd),
      map((e) => e.urlAfterRedirects.startsWith('/admin')),
      startWith(this.router.url.startsWith('/admin')),
    );
  }

  setTheme(theme: AppTheme): void {
    this.themeService.applyTheme(theme);
    this.activeTheme = theme;
  }

  toggleAdminSidenav(): void {
    this.adminLayoutService.toggleAdminSidenav();
  }

  goToProfile(user: UserInfo): void {
    this.router.navigate(['/user', user.username]);
  }

  logout(): void {
    this.authService.logout();
  }

  openInfoDialog() {
    this.dialog.open(InfoDialogComponent, {});
  }
}
